import { createSlice } from '@reduxjs/toolkit'

import { upgradeSubscription } from './actions/upgrade_subscription'

const upgradeSubscriptionSlice = createSlice({
  name: 'upgradeSubscription',
  initialState: {
    loading: false,
    cardError: null,
    upgradeSuccessful: false
  },
  reducers: {
    resetUpgradeStatus: (state) => {
      state.loading = false
      state.cardError = null
      state.upgradeSuccessful = false
    },
    setUpgradeSuccessful: (state) => {
      state.loading = false
      state.cardError = null
      state.upgradeSuccessful = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(upgradeSubscription.pending, (state) => {
      state.loading = true
      state.cardError = null
    })
    builder.addCase(upgradeSubscription.fulfilled, (state) => {
      state.loading = false
      state.upgradeSuccessful = true
      state.cardError = null
    })
    builder.addCase(upgradeSubscription.rejected, (state, action) => {
      state.loading = false
      state.upgradeSuccessful = false
      if (action.payload.isCardError) {
        state.cardError = action.payload.error
      }
    })
  }
})

export const {
  reducer,
  actions: {
    resetUpgradeStatus,
    setUpgradeSuccessful
  }
} = upgradeSubscriptionSlice
